function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.872 177.121c0 74.683 60.55 135.25 135.242 135.25 74.716 0 135.266-60.567 135.266-135.25 0-74.708-60.55-135.25-135.266-135.25",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 8.33333
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.389 84.438c-49.7 43.625-54.017 119.975-9.625 170.525 44.4 50.525 120.65 56.141 170.341 12.5 49.692-43.65 53.992-119.984 9.609-170.525",
  fill: "none",
  stroke: "#7e8959",
  strokeWidth: 8.33333
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M316.523 305.406c7.94 9.827 6.38 24.268-3.438 32.18-9.87 7.952-24.276 6.396-32.213-3.454-7.927-9.826-6.363-24.26 3.489-32.21 9.814-7.928 24.247-6.352 32.162 3.484",
  fill: "#7e8959",
  fillRule: "nonzero"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.305 219.204c22.492 53.725 85.534 78.525 140.767 55.392 55.233-23.142 81.783-85.45 59.292-139.167-22.484-53.708-85.525-78.5-140.775-55.383",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 2.0833325
});

function SvgLogomarkinline(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 355 355",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 10
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgLogomarkinline;